import { HpSvgIconTypes, SvgIcon } from '@avantia/style-guide';
import { ReactElement } from 'react';
import { getConfig } from '../../config/configuration';
import { HpLoadingWidgetProps } from '../../engineClient/components/widgets/widgetTypes';

// TODO - Pass child element to render different text/style on different pages.
export function LoadingWidget({ viewport, loadingText, loadingSubText }: HpLoadingWidgetProps): ReactElement {
  const { height, isMobile, isTablet, width } = viewport;
  const loadingHeaderText = loadingText;
  const loadingSubParagraphText = loadingSubText;
  const { assetsUrl, logoPath } = getConfig();
  const marginTop = !isMobile ? `${Math.floor(isTablet ? 50 : height * 0.15)}px` : undefined;
  const divWidth = isMobile ? `${width - 30}px` : undefined;

  return (
    <>
      <div className="hp-overlay-box"></div>
      <div className="hp-loading-widget-screen" style={{ width: `${width}px`, height: `${height}px` }}>
        <div style={{ marginTop, width: divWidth }}>
          <img className="logo" src={assetsUrl + logoPath} alt="Homeprotect logo" />
          <div>
            <div>
              <div className="hp-loading-icon-container">
                {<SvgIcon type={'file-invoice' as HpSvgIconTypes} size="large" />}
              </div>
            </div>
            <h2>{loadingHeaderText ? loadingHeaderText : 'Loading'}</h2>
            <img
              alt="page loading animation"
              className="page-loading-anim"
              height={isMobile ? 32 : 64}
              src={assetsUrl + 'website/page-loading.gif'}
              width={64}
            />
          </div>
          <p>{loadingSubParagraphText ? loadingSubParagraphText : 'Please wait while we gather your information.'}</p>
        </div>
      </div>
    </>
  );
}
